import { IGrantData, IGrant, IGrantSummary, IScheduleSummary, IProgressSummary, IReportSchedule, IGrantee } from './grant.types';
import { ValidationMessage, IValidationMessage } from '../common'

export class GrantData implements IGrantData {

    selectedGrant: IGrant
    grantData: any
    showValidationDilog: boolean
    validationMessages: Array<IValidationMessage>

    constructor(grant: IGrantData) {
        this.selectedGrant = grant.selectedGrant || {} as IGrant;
        this.grantData = grant.grantData || {}
        this.showValidationDilog = grant.showValidationDilog || false
        this.validationMessages = (grant.validationMessages || []).map((x) => new ValidationMessage(x))
    }
}

/** class for Grant */
export class Grant implements IGrant {
    ApplicationId: number
    GrantId: number
    Title: string
    Country: string
    RequestedAmount: number
    TotalProjectBudget: number
    ProjectDuration: string
    StartDate: Date
    EndDate: Date
    ActualStartDate: Date
    ExpectedEndDate: Date
    LeadPartner: string
    InitiativeCallId: number
    InitiativeId: number
    WorkflowStatusId: number
    WorkflowStatusCode: string
    CreatedById: string
    CreatedDate: Date
    Region: string
    Initiative: string
    UpdatedById: Date
    UpdatedDate: Date
    WorkflowInfo: any
    ReportingFrequency: number
    Comments: string
    BudgetCurrency: string
    AgreementDate: Date
    IsAgreementSigned: number
    ApplicantId: number
    GrantCode: string
    GrantSequenceNo: number
    GrantTypeId: number
    UniqueID: string
    PrimaryProgramOfficerId: number
    IsConfidential: number
    BudgetType: string
    Subject: string
    notify: boolean
    constructor(grant: IGrant) {
        this.ApplicationId = grant.ApplicationId
        this.GrantId = grant.GrantId
        this.Title = grant.Title
        this.InitiativeCallId = grant.InitiativeCallId
        this.Country = grant.Country
        this.WorkflowStatusId = grant.WorkflowStatusId
        this.WorkflowStatusCode = grant.WorkflowStatusCode
        this.RequestedAmount = grant.RequestedAmount
        this.CreatedById = grant.CreatedById
        this.CreatedDate = grant.CreatedDate
        this.Region = grant.Region
        this.Initiative = grant.Initiative
        this.UpdatedById = grant.UpdatedById
        this.UpdatedDate = grant.UpdatedDate
        this.TotalProjectBudget = grant.TotalProjectBudget
        this.ProjectDuration = grant.ProjectDuration
        this.StartDate = grant.StartDate
        this.EndDate = grant.EndDate
        this.LeadPartner = grant.LeadPartner
        this.WorkflowInfo = grant.WorkflowInfo
        this.ReportingFrequency = grant.ReportingFrequency
        this.Comments = grant.Comments
        this.BudgetCurrency = grant.BudgetCurrency
        this.AgreementDate = grant.AgreementDate
        this.IsAgreementSigned = grant.IsAgreementSigned
        this.ApplicantId = grant.ApplicantId
        this.GrantCode = grant.GrantCode
        this.GrantSequenceNo = grant.GrantSequenceNo
        this.GrantTypeId = grant.GrantTypeId
        this.UniqueID  = grant.UniqueID
        this.PrimaryProgramOfficerId = grant.PrimaryProgramOfficerId
        this.IsConfidential = grant.IsConfidential
        this.BudgetType = grant.BudgetType
        this.ActualStartDate = grant.ActualStartDate
        this.ExpectedEndDate = grant.ExpectedEndDate
        this.Subject = grant.Subject
        this.notify = grant.notify
    }
}

export class GrantSummary implements IGrantSummary {
    Schedule: IScheduleSummary
    Progress: Array<IProgressSummary>
    ProgressItems: Array<Object>
    Grantees: Array<IGrantee>;

    constructor(summary: IGrantSummary) {
        this.Schedule =  new ScheduleSummary(summary.Schedule || {} as IScheduleSummary);
        this.Progress = (summary.Progress || []).map((x) => new ProgressSummary(x));
        this.ProgressItems = summary.ProgressItems || [];
        this.Grantees = (summary.Grantees || []).map((x) => new Grantee(x));
    }
}

export class ScheduleSummary implements IScheduleSummary {
    TechnicalReports: Array<IReportSchedule>
    FinancialReports: Array<IReportSchedule>

    constructor(summary: IScheduleSummary) {
        this.TechnicalReports = (summary.TechnicalReports || []).map((x) => new ReportSchedule(x))
        this.FinancialReports = (summary.FinancialReports || []).map((x) => new ReportSchedule(x))
    }
}

export class ReportSchedule implements IReportSchedule {
    ReportId: number
    Title: string
    StartDate: Date
    EndDate: Date
    DueDate: Date
    Status: string
    WorkFlowStepId: number
    ScheduleStatus: string

    constructor(schedule: IReportSchedule) {
        this.ReportId = schedule.ReportId
        this.Title = schedule.Title
        this.StartDate = schedule.StartDate
        this.EndDate = schedule.EndDate
        this.DueDate = schedule.DueDate
        this.Status = schedule.Status
        this.ScheduleStatus = schedule.ScheduleStatus
    }
}

export class ProgressSummary implements IProgressSummary {
    ResultId: string
    Description: string
    Progress: number

    constructor(summary: IProgressSummary) {
        this.ResultId = summary.ResultId
        this.Progress = summary.Progress
        this.Description = summary.Description
    }
}


export class Grantee implements IGrantee {
    UserId: string
    UserName: string

    constructor(grantee: IGrantee) {
        this.UserId = grantee.UserId
        this.UserName = grantee.UserName
    }
}